module.exports = __webpack_public_path__ + "img/secondday1-1.6533e377.jpg";